export enum TYPE {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LIGHT = 'light',
  DARK = 'dark',
  LINK = 'link',
  ROUNDED_LIGHT = 'rounded-light',
  ROUNDED_REGULAR = 'rounded-regular'
}
